'use strict';

const CONST = require('plugin_frontend_core/constants');
const swiper = require('plugin_frontend_components/components/sliders');

const selectors = {
    product: {
        quickviewSlide: '.js-product-quickview-slide',
        quickviewSlideLink: '.js-product-quickview-slide a',
        attributes: {
            container: '.product-attributes',
            item: '.product-attributes__item',
            selected: '.product-attributes__item.selected'
        }
    }
};

const classes = {
    product: {
        attributes: {
            errorState: 'product-attributes--error'
        }
    }
};

module.exports = {
    addToWishlist: function () {
        $(document).on(CONST.events.click, CONST.selectors.product.addToWishlist, function clickAddToWishlist(e) {
            e.preventDefault();

            const $self = $(this);
            const isPDP = $self.closest(CONST.selectors.product.detailPage).length > 0;
            if (isPDP) {
                $(document).off(CONST.events.click, CONST.selectors.product.addToWishlist, clickAddToWishlist);
                return;
            }
            const $productContainer = $self.closest(CONST.selectors.product.jsProductContainer);
            let isReady = true;

            // Loop over all attributes
            const $productAttributes = $productContainer.find(CONST.selectors.product.attributes.container);
            $productAttributes.each(function () {
                const $productAttribute = $(this);
                const hasAttributeItems = $productAttribute.find(CONST.selectors.product.attributes.item).length > 0; // does the attribute have any items/variations?
                const noSelectedAttribute = $productAttribute.find(CONST.selectors.product.attributes.selected).length === 0; // does the attribute not have a selected item/variation?

                if (hasAttributeItems && noSelectedAttribute) {
                    isReady = false;
                    e.stopImmediatePropagation();
                }
            });

            const pid = $productContainer.attr(CONST.attributes.product.productID);
            const urlAdd = $self.attr(CONST.attributes.urlAdd);
            const urlRemove = $self.attr(CONST.attributes.urlRemove);

            const addToWishlistData = {
                origin: 'tile.js',
                pid: pid,
                trigger: $self,
                urlAdd: urlAdd,
                urlRemove: urlRemove,
                isReady: isReady
            };

            window.pubSub.publish(CONST.pubSubEvents.wishlist.clickAddToWishlist, addToWishlistData);
        });
    },
    variationChange: function () {
        $(document).on(CONST.events.click, selectors.product.quickviewSlideLink, function tileVariationChange(e) {
            e.preventDefault();

            swiper.initProductTileSwiper();

            const $link = $(this);
            const $swiper = $link.closest('.js-tile-attr-slider')[0].swiper;
            const $currSlide = $link.closest('.swiper-slide');
            const $slideIndex = $currSlide.index();
            const $productContainer = $link.closest(CONST.selectors.product.jsProductContainer);
            const $productAttributes = $productContainer.find(selectors.product.attributes.container);
            const pid = $link.attr(CONST.attributes.product.productID);
            const $wishlistTrigger = $productContainer.find(CONST.selectors.product.addToWishlist);

            // Update some attributes
            $productContainer.attr(CONST.attributes.product.productID, pid);
            $productContainer.find(CONST.selectors.product.productContainer).attr(CONST.attributes.product.productID, pid);
            $productContainer.find(CONST.selectors.product.addToCart).attr(CONST.attributes.product.productID, pid);

            // Remove the error class
            $productAttributes.removeClass(classes.product.attributes.errorState);

            // Add an active/selected class to the current slide and remove it on the others
            $swiper.slideTo($slideIndex);

            $currSlide
                .addClass('selected')
                .siblings('.swiper-slide')
                .removeClass('selected');

            if (window.sfStates.customer.isLoggedIn) {
                // getting the actual state of the product for the wishlist
                // we can't rely on the data attribute only because the product tile is cached
                $.get($link.attr(CONST.attributes.product.isInWishlistURL)).then(response => {
                    $wishlistTrigger.toggleClass(CONST.classes.product.isInWishlist, response.isInWishlist);
                });
            }
        });
    }
};
